import PropTypes from "prop-types";
import React from "react";

import QuestionAnswerDisplay, {
    getAnswerDisplayPropsFromAnswer,
} from "common/Question/AnswerDisplay";
import { alphaNumeric } from "lib/propTypes";

const SelectOneRadio = ({ answer, id, readOnly, handleSelect, response }) => (
    <ul className="radio-list radio-list-left questions__list">
        {answer.map((a) => (
            <li key={a.id}>
                <input
                    data-id={a.id}
                    defaultChecked={a.id === response?.response}
                    disabled={readOnly}
                    id={`reason-${a.id}`}
                    onChange={handleSelect}
                    name={`select-one-${id}`}
                    type="radio"
                />
                <label htmlFor={`reason-${a.id}`} className="questions__list-label">
                    <QuestionAnswerDisplay {...getAnswerDisplayPropsFromAnswer(a)} />
                </label>
            </li>
        ))}
    </ul>
);

SelectOneRadio.propTypes = {
    answer: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    id: alphaNumeric.isRequired,
    readOnly: PropTypes.bool,
    handleSelect: PropTypes.func.isRequired,
    response: PropTypes.shape({
        response: PropTypes.string,
    }),
};

SelectOneRadio.defaultProps = {
    response: null,
    readOnly: false,
};

export default React.memo(SelectOneRadio);
